import GROW2384_ACTIONS from '~app/pages/Pricing/experiments/grow_2384_response_toggle/actions';
import GROW2529_ACTIONS from '~app/pages/Pricing/experiments/grow_2529_forms/actions';

export enum PACKAGE_ACTIONS {
  UPDATE_PACKAGES = 'UPDATE_PACKAGES',
  UPDATE_PACKAGES_TO_DISPLAY = 'UPDATE_PACKAGES_TO_DISPLAY',
  SWITCH_PACKAGES = 'SWITCH_PACKAGES',
}

const ACTIONS = { ...PACKAGE_ACTIONS, ...GROW2384_ACTIONS, ...GROW2529_ACTIONS };

export default ACTIONS;
